class ClientDelegate {
    setRecentAudits(recentAudits) {
        this.setState((prevState) => {
            return { recentAudits };
        });
    }

    setElementsLoading(elementsLoading) {
        this.setState((prevState) => {
            return { elementsLoading };
        });
    }

    setFiltered(filtered) {
        this.setState((prevState) => {
            return { filtered };
        });
    }

    setSelectedStores(selectedStores) {
        this.setState((prevState) => {
            return { selectedStores };
        });
    }
}

export default ClientDelegate;
